import classNames from 'classnames';
import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import './Accordion.css';

// Props
// The thing you can click on to open or close the accordion
// header: JSX.Element | string
// openInitially: boolean
// if inverted it opens up instead of down
// inverted?: boolean
// className?: string
// closeAfter?: number

export default class Accordion extends Component {
  // closeTimeout: number;
  // contentRef: HTMLElement | null;

  constructor(props) {
    super(props);

    this.state = {
      open: props.openInitially,
      height: 0
    };

    this.close = this.close.bind(this);
  }

  componentDidMount() {
    this.contentRef && this.setState({
      height: this.contentRef.getBoundingClientRect().height
    });
    if (this.props.closeAfter && this.props.openInitially) {
      this.closeTimeout = window.setTimeout(this.close, this.props.closeAfter);
    }
  }

  componentWillUnmount() {
    window.clearTimeout(this.closeTimeout);
  }

  componentDidUpdate() {
    const newHeight = this.contentRef ? this.contentRef.getBoundingClientRect().height : 0;
    const actualHeight = this.state.open ? newHeight : 0;
    if (this.state.height !== actualHeight) {
      this.setState({
        height: actualHeight
      });
    }
  }

  close = () => {
    this.setState({
      open: false
    });
  }

  onClickHeader = () => {
    window.clearTimeout(this.closeTimeout);
    const newOpen = !this.state.open;
    let newHeight = 0;
    if (newOpen && this.contentRef) {
      newHeight = this.contentRef.getBoundingClientRect().height;
    }
    this.setState({
      open: newOpen,
      height: newHeight
    });
  }

  getClosedImage() {
    if (this.props.inverted) {
      return <img alt={'ArrowUp'} src={`${process.env.PUBLIC_URL}/images/icons/ArrowUp.png`} />;
    }
    else {
      return <img alt={'ArrowDown'} src={`${process.env.PUBLIC_URL}/images/icons/ArrowDown.png`} />;
    }
  }

  getOpenImage() {
    if (this.props.inverted) {
      return <img alt={'ArrpwDown'} src={`${process.env.PUBLIC_URL}/images/icons/ArrowDown.png`} />;
    }
    else {
      return <img alt={'ArrowUp'} src={`${process.env.PUBLIC_URL}/images/icons/ArrowUp.png`} />;
    }
  }

  render() {
    const addedClasses = this.props.className || '';
    const accordionClasses = classNames(addedClasses, 'Accordion', {
      'Accordion--open': this.state.open
    });

    const curHeight = this.state.open ? this.state.height : 0;
    const contentContainerStyles = {
      height: curHeight,
      transition: 'height 0.5s'
    };

    return (
      <div className={accordionClasses}>
        {this.props.inverted && (
          <Scrollbars className={'Accordion-contentContainer'} style={contentContainerStyles}>
            <div className={'Accordion-content'} ref={(x) => { this.contentRef = x; }}>
              {this.props.children}
            </div>
          </Scrollbars>
        )}
        <div className={'Accordion-header'} onClick={this.onClickHeader}>
          <div className={'Accordion-headerContent'}>
            {this.props.header}
          </div>
          <div className={'Accordion-headerIcon'}>
            {this.state.open
              ? this.getOpenImage()
              : this.getClosedImage()
            }
          </div>
        </div>
        {!this.props.inverted && (
          <div className={'Accordion-contentContainer'} style={contentContainerStyles}>
            <div className={'Accordion-content'} ref={(x) => { this.contentRef = x; }}>
              {this.props.children}
            </div>
          </div>
        )}
      </div>
    );
  }
}
